const url = "https://fingoww.onrender.com";
export default url;